import { InjectionToken } from '@angular/core';

export const TOOL_KEY = new InjectionToken<toolKey>('toolKey');
export const RETURN_URL = new InjectionToken<string>('returnUrl');

export type toolKey = 'easydgd' | 'rhb' | 'smart-comp' | 'iata-check' | 'smart-identify' | 'smart-label' | 'smart-package';
